import {
  LOAD_GPS_CERT,
  LOAD_GPS_CERT_DETAIL,
  LOAD_GPS_CERT_HISTORY,
  REMOVE_LISTS
} from "./actions";
var loading = false;
var page = 1;
const initialState = {
  lists: [],
  detailLists: [],
  total: 1,
  detailTotal: 1,
  loading: false,
  detailLoading: false,
  draw: -1
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;
    case LOAD_GPS_CERT_HISTORY.REQUEST:
      loading = action.payload.loading;
      return {
        ...state,
        loading: loading
      };
    case LOAD_GPS_CERT_HISTORY.SUCCESS:
      page = action.payload.page;
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1;
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10;
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };

    case LOAD_GPS_CERT.REQUEST:
      loading = action.payload.loading;
      return {
        ...state,
        loading: loading
      };
    case LOAD_GPS_CERT.SUCCESS:
      page = action.payload.page;
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1;
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10;
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    case LOAD_GPS_CERT_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading:
          typeof action.payload.data.intervalLoading === "undefined"
      };
    case LOAD_GPS_CERT_DETAIL.SUCCESS:
      return {
        ...state,
        detailLists: action.payload.lists,
        detailTotal: action.payload.lists.length,
        detailLoading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    default:
      return state;
  }
};
